<template lang="pug">
  b-modal#matchLogInfo(
  ref="matchLogInfoModal"
  :title="$t('ui.match_log')"
  centered
  no-fade
  ok-only
  no-enforce-focus
  size="xl"
  :busy="loading"
  @shown="shown")
    div(v-if="detail")
      div(v-if="filteredOldDetailList.length > 0")
        b-form-group(:label="$t('ui.old')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $tc("ui.leagues", 1) }}
                    th(width=200)
                      span {{ $t("ui.home") }}
                    th(width=200)
                      span {{ $t("ui.away") }}
                    th(width=80)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th(width=80)
                      span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                    th(width=80)
                      span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                    th(width=80)
                      span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                    th(width=60)
                      span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                    th(width=60)
                      span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                    th(width=50)
                      span(:title="$t('ui.home_red_card')") {{ $t("ui.short.home_red_card") }}
                    th(width=50)
                      span(:title="$t('ui.away_red_card')") {{ $t("ui.short.away_red_card") }}
                    th(width=200)
                      span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
                tbody
                  tr(v-for="item in filteredOldDetailList")
                    td
                      span {{ item.match_id }}
                    td
                      span {{ item.sport_type }}
                    td
                      span(:title="item.league_name") {{ item.league_name }}
                    td
                      span(:title="item.home_name") {{ item.home_name }}
                    td
                      span(:title="item.away_name") {{ item.away_name }}
                    td.text-uppercase
                      span {{ item.market_type }}
                    td
                      span {{ $moment(item.match_date).format("YYYY-MM-DD")  }}
                    td
                      span {{ item.match_time }}
                    td
                      span {{ item.match_link }}
                    td
                      span {{ item.running_score }}
                    td
                      span {{ item.running_time }}
                    td
                      span(:title="item.hrc") {{ item.hrc }}
                    td
                      span(:title="item.arc") {{ item.arc }}
                    td
                      span(:title="item.parent_league_name")  {{ item.parent_league_name }}
      div(v-if="filteredNewDetailList.length > 0")
        b-form-group(:label="$t('ui.new')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th(width=100)
                      span {{ $t('ui.id') }}
                    th(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th
                      span {{ $tc("ui.leagues", 1) }}
                    th(width=200)
                      span {{ $t("ui.home") }}
                    th(width=200)
                      span {{ $t("ui.away") }}
                    th(width=80)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th(width=80)
                      span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                    th(width=80)
                      span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                    th(width=80)
                      span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                    th(width=60)
                      span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                    th(width=60)
                      span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                    th(width=50)
                      span(:title="$t('ui.home_red_card')") {{ $t("ui.short.home_red_card") }}
                    th(width=50)
                      span(:title="$t('ui.away_red_card')") {{ $t("ui.short.away_red_card") }}
                    th(width=200)
                      span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
                tbody
                  tr(v-for="item in filteredNewDetailList")
                    td
                      span {{ item.match_id }}
                    td
                      span {{ item.sport_type }}
                    td
                      span(:title="item.league_name") {{ item.league_name }}
                    td
                      span(:title="item.home_name") {{ item.home_name }}
                    td
                      span(:title="item.away_name") {{ item.away_name }}
                    td.text-uppercase
                      span {{ item.market_type }}
                    td
                      span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                    td
                      span {{ item.match_time }}
                    td
                      span {{ item.match_link }}
                    td
                      span {{ item.running_score }}
                    td
                      span {{ item.running_time }}
                    td
                      span(:title="item.hrc") {{ item.hrc }}
                    td
                      span(:title="item.arc") {{ item.arc }}
                    td
                      span(:title="item.parent_league_name")  {{ item.parent_league_name }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    detail: {
      type: Object
    },
    page: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      recordList: []
    };
  },
  computed: {
    filteredOldDetailList() {
      return this.recordList.filter((item) => {
        return item.type.toLowerCase() == 'old';
      });
    },
    filteredNewDetailList() {
      return this.recordList.filter((item) => {
        return item.type.toLowerCase() == 'new';
      });
    },
  },
  methods: {
    getRecord() {
      let url = config.auditLogDetailRecordUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog,
        log_id: this.detail.log_id,
        log_detail_id: this.detail.log_detail_id,
        audit_table_name: this.detail.audit_table_name
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.recordList = response.data.tbl_audit_log_detail_record;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    shown() {
      this.getRecord();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
